import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var Forward10Icon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M13.951 3.185a1 1 0 011.82-.83l.83 1.82a2 2 0 01-.99 2.649l-1.819.83a1 1 0 01-.83-1.82l.828-.377a7.454 7.454 0 00-8.224 3.549 7.45 7.45 0 1013.921 3.647 1 1 0 012-.015 9.45 9.45 0 11-7.405-9.167l-.13-.286z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M14.136 16.09c-.804 0-1.404-.222-1.8-.666-.39-.444-.603-1.026-.639-1.746a25.812 25.812 0 01-.009-.828c0-.396.003-.678.009-.846.03-.708.246-1.284.648-1.728.402-.444.999-.666 1.791-.666.792 0 1.389.222 1.791.666.402.444.618 1.02.648 1.728.012.336.018.618.018.846 0 .228-.006.504-.018.828-.036.72-.252 1.302-.648 1.746-.39.444-.987.666-1.791.666zm0-1.053c.372 0 .651-.12.837-.36.186-.246.285-.594.297-1.044.006-.174.009-.44.009-.8 0-.36-.003-.622-.009-.784-.012-.438-.111-.78-.297-1.026s-.465-.372-.837-.378c-.372.006-.651.132-.837.378-.186.246-.285.588-.297 1.026-.006.162-.009.423-.009.783 0 .36.003.627.009.801.012.45.111.798.297 1.044.186.24.465.36.837.36zM9.493 16a.208.208 0 01-.153-.063.208.208 0 01-.063-.153V11.14l-1.359 1.044a.204.204 0 01-.135.045.198.198 0 01-.17-.09l-.388-.504a.216.216 0 01-.045-.126c0-.072.033-.132.1-.18l2.015-1.566A.41.41 0 019.52 9.7h.81c.06 0 .111.021.153.063a.208.208 0 01.063.153v5.868c0 .06-.02.111-.063.153a.208.208 0 01-.153.063h-.837z"
                        })
                    ]
                })
            })
        ]
    });
};
Forward10Icon.isCarinaIcon = true;
export default Forward10Icon;
